module.exports = __webpack_public_path__ + "static/DY5-4212265cd1617ce785fd1975bf0cc762.jpg";